const config = require('./../environment');

module.exports = config.isProduction() ? require('./company-api') : require('./mock-company-api');
  